/**
 * Admin wordmark — kopechka wordmark PNG + "Yönetim" suffix tag.
 *
 * Mockup uses `kopechka-wordmark-dark.png` on light theme and
 * `kopechka-wordmark-light.png` on dark theme.  The `.logo-wordmark`
 * + `.logo-light-only` / `.logo-dark-only` classes in styles.css
 * toggle visibility automatically when `[data-theme]` flips.
 *
 * Wordmark aspect ratio (832 × 193) is preserved by scaling width
 * to `height * 832 / 193`.
 */

export interface AdminLogoProps {
  readonly height?: number;
}

export function AdminLogo({ height = 22 }: AdminLogoProps): JSX.Element {
  const width = Math.round((height * 832) / 193);
  return (
    <span
      className="flex-row gap-2"
      style={{ alignItems: 'center', gap: 8 }}
      aria-label="Kopechka Yönetim"
    >
      <span
        className="logo-wordmark"
        style={{ display: 'inline-block', height, lineHeight: 0 }}
      >
        <img
          className="logo-light-only"
          src="/assets/kopechka-wordmark-dark.png"
          alt="Kopechka"
          width={width}
          height={height}
          style={{ height, width: 'auto' }}
        />
        <img
          className="logo-dark-only"
          src="/assets/kopechka-wordmark-light.png"
          alt=""
          aria-hidden="true"
          width={width}
          height={height}
          style={{ height, width: 'auto' }}
        />
      </span>
      <span className="brand-suffix">Yönetim</span>
    </span>
  );
}
